var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.contentRoutes.length > 0
    ? _c("div", [
        _c("h5", {
          staticClass: "h5 mb-3",
          domProps: {
            textContent: _vm._s(
              _vm.$t("ui.views.content_hubs.related_content_hubs")
            ),
          },
        }),
        _c(
          "div",
          { staticClass: "related-content-hubs mt-3" },
          _vm._l(_vm.contentRoutes, function (route) {
            return _c("ci-content-hub-tile", {
              key: route.slug,
              attrs: { "content-route": route },
            })
          }),
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }